import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

interface IDeleteDocumentInterventionSuccessAction {
  document: {
    deleted: boolean | unknown;
    file_type: string;
    intervention_document_id: number;
  };
}

function deleteDocumentSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IDeleteDocumentInterventionSuccessAction>,
) {
  const { deleted, file_type, intervention_document_id } =
    action.payload.document;
  draft.deleteDocument.config.isLoading = false;

  if (deleted) {
    if (file_type === 'photo_post_repair') {
      draft.getDocuments.documents.photosRepair =
        draft.getDocuments.documents.photosRepair?.filter(document => {
          return document.id !== intervention_document_id;
        });
    } else if (file_type === 'photo_damage') {
      draft.getDocuments.documents.photosDamage =
        draft.getDocuments.documents.photosDamage?.filter(document => {
          return document.id !== intervention_document_id;
        });
    }
  }
}

export default deleteDocumentSuccess;
